import {configureStore} from '@reduxjs/toolkit'

import order from './slices/orderSlice'
import customerInfo from './slices/customerInfoSlice'
import cart from './slices/cartSlice'
import shippingProfiles from './slices/shippingProfilesSlice'
import payment from './slices/paymentSlice'
import transaction from './slices/transactionSlice'
import discounts from './slices/discountsSlice'
import postCartUpsells from './slices/postCartUpsellsSlice'

export default configureStore({
  reducer: {
    order,
    customerInfo,
    cart,
    shippingProfiles,
    payment,
    transaction,
    discounts,
    postCartUpsells
  }
})



// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/store.js